import Cookies from 'js-cookie';
import type { CookieAttributes } from 'js-cookie';

const attributes: CookieAttributes = { path: '/', sameSite: 'None', secure: true };

interface CookieStore {
  get: (_key: string) => string | undefined;
  set: (_key: string, _value: string, _options?: CookieAttributes) => string | undefined;
  remove: (_key: string, _options?: CookieAttributes) => void;
}

function hasWithAttributes(
  cookies: typeof Cookies,
): cookies is typeof Cookies & { withAttributes: (_attrs: CookieAttributes) => typeof Cookies } {
  return 'withAttributes' in cookies && typeof cookies.withAttributes === 'function';
}

let cookieStore: CookieStore;
if (Cookies && hasWithAttributes(Cookies)) {
  cookieStore = Cookies.withAttributes(attributes);
} else if (Cookies) {
    cookieStore = Cookies;
} else {
    cookieStore = {
        get: () => undefined,
        set: () => undefined,
        remove: () => undefined,
    };
}

export default {
    get (key: string): string | undefined {
        return cookieStore.get(key);
    },
    set (key: string, value: string, options: CookieAttributes = {}): void {
        cookieStore.set(key, value, { ...attributes, ...options });
    },
    remove (key: string, options: CookieAttributes = {}): void {
        cookieStore.remove(key, { ...attributes, ...options });
    }
}
